import { render, staticRenderFns } from "./VideoInline.vue?vue&type=template&id=711945ab&scoped=true"
import script from "./VideoInline.js?vue&type=script&lang=js&external"
export * from "./VideoInline.js?vue&type=script&lang=js&external"
import style0 from "./VideoInline.scss?vue&type=style&index=0&id=711945ab&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711945ab",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
